<template>
  <div class="w-100">

    <b-navbar toggleable="lg" variant="light">

      <b-navbar-brand>
        <m-a :href="{name:'Home'}">
          <img :src="findAttributeOnSiteInfo('icon')[0]" alt="logo" width="80" height="auto"
               class="d-inline-block align-text-top"/>
        </m-a>
      </b-navbar-brand>


      <b-navbar-toggle target="nav-501-collapse" class="ml-2"></b-navbar-toggle>

      <b-collapse id="nav-501-collapse" is-nav>

        <b-navbar-nav class="col-10 col-md-10 col-sm-12 text-center">
          <b-navbar-nav class="align-items-baseline " v-for="menu in storeMenus" :key="menu.id"
                        v-if="menu.position === 'store_nav'">


            <NavMenuItem v-for="item in menu.children" :item="item" :key="item.id"/>
          </b-navbar-nav>
        </b-navbar-nav>

        <m-search-input-1 class=" col-lg-2 col-md-2 col-sm-12"  />

        <!-- Right aligned nav items -->
        <b-navbar-nav class="ml-auto mr-auto text-center">
          <slot/>
        </b-navbar-nav>

      </b-collapse>

    </b-navbar>

  </div>

</template>

<script>
import NavMenuItem from './NavMenuItem'
import {mapGetters} from "vuex";

export default {
  name: "Nav501",
  components: {NavMenuItem},
  computed: {
    ...mapGetters({
      storeMenus: "Menu/getStoreMenus",
    }),
  },
};
</script>

<style scoped>
.nav-button-501 {
  background-color: var(--light-red);
  color: var(--light);
  width: 170px;
  padding: 10px;
  border: 2px solid rgb(173, 72, 80);
  font-size: 15px;
}

.nav-button-501:hover {
  background-color: var(--light);
  color: var(--light-red);
  border: 2px solid rgb(173, 72, 80);
}

/*  item-nav */
.item-nav-501 {
  color: var(--light-teal) !important;
  font-weight: bold;
}

.item-nav-501:hover {
  color: var(--light-red) !important;
}
</style>